export const types = {
    DATATRANSFORM: 'DATA-TRANSFORM',
    RUNCOMMAND: 'RUN-COMMAND',
    GOTO: 'GO-TO'
};